export default {
    namespaced: true,
    state: {
        browserInfo: {}, // 浏览器信息
        clientWidth: '', // 当前屏幕宽度
        equipmentInfo: {}, // 来源设备信息

        navTop: 0,
        statusBarHeight: 0, // 设备状态栏高度
        navHeight: 0, // 导航栏高度
    },
    getters: {
        get_browser: state => {
            return state.browserInfo
        },
        get_clientWidth: state => {
            return state.clientWidth
        },
        get_equipment: state => {
            return state.equipmentInfo
        },
        get_navTop: state => {
            return state.navTop
        },
        get_statusBarHeight: state => {
            return state.statusBarHeight
        },
        get_navHeight: state => {
            return state.navHeight
        },
    },
    mutations: {
        setClientWidth(state, clientWidth) {
            state.clientWidth = clientWidth
        },
        // 获取浏览器设备
        getBrowser: (state) => {
            var u = navigator.userAgent;
            var ua = navigator.userAgent.toLocaleLowerCase();
            state.browserInfo = {
                // 未知
                ucLowEnd: u.indexOf('UCWEB7.') > -1, //
                ucSpecial: u.indexOf('rv:1.2.3.4') > -1,
                webview: !(u.match(/Chrome\/([\d.]+)/) || u.match(/CriOS\/([\d.]+)/)) && u.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
                Symbian: u.indexOf('Symbian') > -1,
                ucSB: u.indexOf('Firofox/1.') > -1,

                // pc端
                trident: u.indexOf('Trident') > -1, // IE内核
                presto: u.indexOf('Presto') > -1, // opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
                QQbrw: u.indexOf('MQQBrowser') > -1, // QQ浏览器
                Mibrw: u.indexOf('MiuiBrowser') > -1, // 小米自带浏览器
                webApp: u.indexOf('Safari') == -1, // 是否web应用程序，没有头部与底部
                ucweb: function () {
                    try {
                        return parseFloat(u.match(/ucweb\d+\.\d+/gi).toString().match(/\d+\.\d+/).toString()) >= 8.2
                    } catch (e) {
                        if (u.indexOf('UC') > -1) {
                            return true;
                        }
                        return false;
                    }
                }(),

                // 移动端
                mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
                hupu: ua.indexOf('kanqiu') > -1, // 虎扑客户端
                douyin: u.indexOf('aweme') > -1, // 抖音客户端
                kuaishou: u.indexOf('KsWebView') > -1, // 快手客户端
                zhihu: u.indexOf('ZhihuHybrid') > -1, // 知乎客户端
                weibo: ua.match(/WeiBo/i) == "weibo", // 微博
                bilibili: u.indexOf('BiliApp') > -1, // bilibili客户端
                xiaohongshu: ua.indexOf('xiaohongshu') > -1, // 小红书客户端
                taobao: ua.indexOf('taobao') > -1, // 淘宝客户端
                toutiao: ua.indexOf('toutiao') > -1, // 头条客户端
                ximalaya: ua.indexOf('ximalaya') > -1, // 喜马拉雅客户端
                weiXin: u.indexOf('MicroMessenger') > -1, // 微信
                QQ: ua.match(/QQ/i) == "qq", // QQ
            };
        },
        // 埋点
        buriedPoint: (state, {
            title,
            value
        }) => {
            const promise = () => {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        if (window._czc) resolve()
                        else resolve(promise())
                    }, 100)
                })
            }
            promise().then(() => {
                // console.log(title, value)
                window._czc.push(['_trackEvent', title, value])
            })
        },
        setEquipment(state, equipment) {
            const isIos = platform => platform == 'iPhone';
            const isAndroid = platform => {
                return !isIos(platform) && !isPc(platform)
            };
            const isPc = platform => {
                return platform.indexOf('Win') === 0 || platform.indexOf('Mac') === 0
            };

            state.equipmentInfo = {
                equipment, // 来源设备
                ios: isIos(equipment),
                android: isAndroid(equipment),
                pc: isPc(equipment),
            }
        },

        // 获取设备信息
        get_system_info(state, statusBarHeight /* 设备状态栏高度 */ ) {
            // 设备状态栏高度存入本地，防止跳转其他域名再回来时获取不到高度
            statusBarHeight = statusBarHeight || sessionStorage.getItem('statusBarHeight') || 46
            sessionStorage.setItem('statusBarHeight', statusBarHeight)

            let menuButtonObject = {
                top: 23,
                height: 0,
            }
            let navTop = menuButtonObject.top;
            state.navTop = navTop;
            // console.log(`设备像素比：${window.devicePixelRatio}`)
            // console.log(`设备实际高度：${+statusBarHeight / window.devicePixelRatio}`)
            state.statusBarHeight = +statusBarHeight / window.devicePixelRatio;
            // 导航栏高度 = 设备状态栏高度 + 32（此处的32是header组件内写死的样式高度）
            state.navHeight = state.statusBarHeight + 32;
            localStorage.setItem('navTop', navTop)
            localStorage.setItem('navHeight', state.statusBarHeight + 32)
        },
    },
    actions: {

    }
}